<script setup lang="ts">
import EventCheckpointAutocomplete from '@/components/Filters/components/EventCheckpointAutocomplete.vue'
import { GridLayout } from '@/components/Layouts'
import DeviceFilterAutocomplete from '@/components/Selector/components/DeviceFilterAutocomplete.vue'
import { useGridSize } from '@/hooks/useGridSize'
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import type { EventModel } from '@/types/models/EventModel'
import { inject } from 'vue'
import DebouncedInputField from '../../components/Fields/DebouncedInputField.vue'
import { EHubContext } from '../../types/context/HubContextEnum'
import type { CheckpointModel } from '../../types/models/CheckpointModel'

type Props = {
    filters: DetectionFilters
    selectedEvent?: Partial<EventModel>
    selectedCheckpoint?: Partial<CheckpointModel>
}
defineProps<Props>()

type Emits = {
    (e: 'change', value: Partial<DetectionModel>): void
    (e: 'associates', value?: AssociatedDeviceModel[]): void
    (e: 'selectEvent', value?: EventModel): void
    (e: 'selectCheckpoint', value?: CheckpointModel): void
}
defineEmits<Emits>()

const gridSize = useGridSize()

const isViewerOnly = inject<boolean>(EHubContext.IS_VIEWER_ONLY, false)
</script>

<template>
    <GridLayout :maxItemPerRow="gridSize" :gap="8" class="full-width flex-wrap" isResponsive>
        <EventCheckpointAutocomplete
            :event="selectedEvent"
            :event_id="filters.event_id"
            :checkpoint_id="filters.checkpoint_id"
            keepEventInStorage
            filterAllEvents
            @selectEvent="$emit('selectEvent', $event)"
            @selectCheckpoint="$emit('selectCheckpoint', $event)" />
        <DeviceFilterAutocomplete
            :filters="filters"
            :deviceOptions="selectedCheckpoint?.associates ?? selectedEvent?.detection_devices"
            :disabled="isViewerOnly && !filters.checkpoint_id"
            @change="$emit('change', $event)" />
        <DebouncedInputField
            :label="$t('detection.filters.bib')"
            :modelValue="filters.bib"
            :prefix="$t('unit.number')"
            @change="$emit('change', { bib: $event })" />
    </GridLayout>
</template>
